import { useState } from "react";
import { fetchProcessCount } from "../api";
import { EMPTY_COUNTS, parseProcessCount } from "../utils/parsers";
import useDebouncedLoad from "./useDebouncedLoad";

// Loads the stat tiles for `date` (today when null) while `enabled`, and
// again whenever `refreshKey` changes (socket refreshes, debounced).
// status: "idle" | "loading" | "ready" | "error"
export default function useProcessCount(enabled, date, refreshKey = 0) {
  const [counts, setCounts] = useState(EMPTY_COUNTS);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);

  useDebouncedLoad(enabled, refreshKey, [date], (isCancelled) => {
    setStatus((current) => (current === "ready" ? current : "loading"));
    setError(null);
    fetchProcessCount(date)
      .then((data) => {
        if (isCancelled()) return;
        setCounts(parseProcessCount(data));
        setStatus("ready");
      })
      .catch((err) => {
        if (isCancelled()) return;
        setCounts(EMPTY_COUNTS);
        setStatus("error");
        setError(err?.message || "Request failed");
      });
  });

  return { counts, status, error };
}
